/* ============================================================
   Taglio — global chrome behaviour
   Mobile menu toggle, active-link marking, announcement marquee.
   Progressive enhancement only: the header works without JS.
   ============================================================ */
(function () {
  'use strict';

  // ---- Mobile menu (hamburger dropdown) ----
  // Wire EVERY burger to its own menu (via aria-controls) rather than a single
  // document-wide querySelector, so multiple headers on one page all work.
  function initMenu() {
    var burgers = document.querySelectorAll('[data-tg-burger]');
    if (!burgers.length) return;

    var mq = window.matchMedia('(min-width: 760px)');

    Array.prototype.forEach.call(burgers, function (burger) {
      var id = burger.getAttribute('aria-controls');
      var menu = id ? document.getElementById(id) : null;
      if (!menu) {
        // fall back to the nearest following menu
        menu = burger.closest('.tg-header__inner')
          ? burger.closest('.tg-header__inner').querySelector('[data-tg-menu]')
          : null;
      }
      if (!menu) return;

      function setOpen(open) {
        burger.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
        var openIcon = burger.querySelector('.tg-burger__open');
        var closeIcon = burger.querySelector('.tg-burger__close');
        if (openIcon) openIcon.style.display = open ? 'none' : '';
        if (closeIcon) closeIcon.style.display = open ? '' : 'none';
      }

      burger.addEventListener('click', function (e) {
        e.stopPropagation();
        setOpen(burger.getAttribute('aria-expanded') !== 'true');
      });

      // Close on selection
      menu.querySelectorAll('a, button').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (menu.hidden) return;
        if (menu.contains(e.target) || burger.contains(e.target)) return;
        setOpen(false);
      });

      // Close on Escape, return focus to the burger
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) {
          setOpen(false);
          burger.focus();
        }
      });

      // Reset when we cross into the desktop layout, so the dropdown can
      // never be left "open" behind the desktop nav.
      function onChange(ev) { if (ev.matches) setOpen(false); }
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);

      setOpen(false);
    });
  }

  // ---- Mark the current nav item ----
  // The prototype highlights the active lane (Start Here / Shop Bases /
  // Matching Sets). We do it from the URL rather than hard-coding.
  //
  // The three lane links now point at ONE build page and differ only by their
  // ?lane= query, so a bare pathname comparison can never pick between them
  // (and would previously have matched none of them, because the href carried
  // a query string the pathname does not). Score instead of equate:
  //
  //   3  same path AND same lane        -> that lane is open
  //   2  same path, no lane in the URL  -> the page's own default (starter)
  //   1  same path, not a lane link     -> ordinary page link
  //   0  a lane link that is not ours
  function initActiveLinks() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    var m = /[?&]lane=([A-Za-z0-9_-]+)/.exec(window.location.search);
    var curLane = m ? m[1].toLowerCase() : '';

    function resolve(href) {
      var a = document.createElement('a');
      a.href = href;
      return a;
    }

    var links = Array.prototype.slice.call(
      document.querySelectorAll('.tg-header__link, .tg-menu__link')
    );

    var best = null;
    var bestScore = 0;

    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href) return;

      var r = resolve(href);
      var p = r.pathname.replace(/\/+$/, '') || '/';
      if (p === '/') return;                       // the logo, not a lane
      var hit = (p === path) || (path.indexOf(p + '/') === 0);
      if (!hit) return;

      var lm = /[?&]lane=([A-Za-z0-9_-]+)/.exec(r.search);
      var lane = lm ? lm[1].toLowerCase() : '';
      var score = lane
        ? (curLane ? (lane === curLane ? 3 : 0) : (lane === 'starter' ? 2 : 0))
        : 1;

      if (score > bestScore) { bestScore = score; best = a; }
    });

    if (!best) return;

    // The desktop nav and the mobile dropdown render the same five links, so
    // highlight every copy of the winner rather than just the one we picked.
    var label = best.textContent.trim();
    links.forEach(function (a) {
      if (a.textContent.trim() === label) a.classList.add('tg-is-active');
    });
    if (best.closest('.tg-header__nav')) best.setAttribute('aria-current', 'page');
  }

  // ---- Smooth-scroll anchors (New Drops / How it Works on the homepage) ----
  // From another page we navigate home first, then scroll.
  function initSectionLinks() {
    document.querySelectorAll('[data-tg-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-tg-scroll');
        var target = document.querySelector('[data-section="' + id + '"]');
        var home = a.getAttribute('data-tg-home') || '/';
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + id);
        } else {
          e.preventDefault();
          var url = new URL(home, window.location.origin);
          url.hash = id;
          window.location.href = url.toString();
        }
      });
    });
  }

  function boot() {
    initMenu();
    initActiveLinks();
    initSectionLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
